import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface RestaurantStore {
  selectedShopExternalId?: string;
  selectRestaurant: (shopExternalId: string) => void;
  deselectRestaurant: () => void;
}

const useRestaurantStore = create<RestaurantStore>()(
  persist(
    (set) => ({
      selectedShopExternalId: undefined,
      selectRestaurant: (shopExternalId: string) => set({ selectedShopExternalId: shopExternalId }),
      deselectRestaurant: () => set({ selectedShopExternalId: undefined }),
    }),
    {
      name: 'restaurant-storage',
    }
  )
);

export default useRestaurantStore;
